<div [class]="question.cssClasses.progressText">{{ question.progressText }}</div>
